import axios from "axios";
import { user,logout } from "./components/utils/auth";

const UNAUTHORIZED_STATUS = 401;

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    const userData = user();
    
    if (userData && userData.token) {
      config.headers.Authorization = `Bearer ${userData.token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => { return response;},
  (error) => {
    if (error.response?.status === UNAUTHORIZED_STATUS) {
      logout();
    }
    
    return Promise.reject(error);
  }
);

export const api = instance;
